import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = (errors) => [
    {
        id: "select",
        header: ({ table }) => (
            <Checkbox
                checked={
                    table.getIsAllPageRowsSelected() ||
                    (table.getIsSomePageRowsSelected() && "indeterminate")
                }
                onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
                aria-label="Välj alla"
                className='ml-4'
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                checked={row.getIsSelected()}
                onCheckedChange={(value) => row.toggleSelected(!!value)}
                aria-label="Välj rad"
                className={errors.includes(row.original.registrationId) ? '!bg-destructive !border-destructive' : ''}

            />
        ),
        enableSorting: false,
        enableHiding: false,
    },
    {
        accessorKey: "name",
        header: ({ column }) => <DatatableSortButton column={column}>Namn</DatatableSortButton>,
        cell: info => {
            const bunny = info.row.original.bunny;
            return <Link to={`/bunny/${bunny.id}`} className={`text-blue-600 font-medium hover:underline ${errors.includes(info.row.original.registrationId) ? 'text-destructive' : ''}`}
            >{bunny.name}</Link>
        },
    },
    {
        accessorKey: "driver.first_name",
        header: ({ column }) => <DatatableSortButton column={column}>Förare</DatatableSortButton>,
        cell: info => {
            const driver = info.row.original.driver;
            return <span>{`${driver.first_name} ${driver.last_name}`}</span>
        },
    },
];

export function BunniesToMoveDatatable({ bunnies, isLoading, onSelectionChange, errors, originSportClassId }) {
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    // const [filterInput, setFilterInput] = useState("");
    const [rowSelection, setRowSelection] = useState({});
    const [showWithAdvancementPoint, setShowWithAdvancementPoint] = useState(false);

    // Delay function before filtering to reduce bounce
    // useEffect(() => {
    //     const handler = setTimeout(() => {
    //         table.getColumn("name")?.setFilterValue(filterInput);
    //     }, 500);

    //     return () => {
    //         clearTimeout(handler);
    //     };
    // }, [filterInput]);

    const handleAdvancementPointStatus = () => {
        setShowWithAdvancementPoint(prev => !prev);
    };

    const filteredBunnies = useMemo(() => {
        const result = bunnies.filter(bunny => {
            // Check if the bunny has any advancement points in the originSportClassId
            const hasAdvancementPointInOriginClass = bunny.bunny.advancementPoints.some(
                point => point.sport_class_id !== originSportClassId
            );


            if (showWithAdvancementPoint) {
                // When checkbox is checked, show only bunnies WITHOUT advancement points in origin class
                return !hasAdvancementPointInOriginClass;
            } else {
                // When checkbox is unchecked, show all bunnies
                return true;
            }
        });

        return result;
    }, [bunnies, showWithAdvancementPoint, originSportClassId]); // Added originSportClassId as dependency

    const table = useReactTable({
        data: filteredBunnies,
        columns: columns(errors),
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
            rowSelection,
        },
        onRowSelectionChange: setRowSelection,
    });

    useEffect(() => {
        const selectedBunnies = table.getSelectedRowModel().rows.map(row => row.original);
        onSelectionChange(selectedBunnies);
    }, [rowSelection]);

    return (
        <>
            <div className='grid grid-cols-1 gap-3 py-3'>
                {/* <div className='flex gap-3'>
                    <Input
                        id='searchBunny'
                        placeholder="Sök kanin..."
                        value={filterInput}
                        disabled={isLoading || bunnies.length === 0}
                        onChange={event => setFilterInput(event.target.value)}
                        className="max-w-sm"
                    />
                </div> */}
                <div className='flex items-center gap-2'>
                    <Label className='flex gap-2 items-center'>
                        <Checkbox
                            checked={showWithAdvancementPoint}
                            onCheckedChange={handleAdvancementPointStatus}
                            disabled={isLoading || bunnies.length === 0} />
                        Visa endast kaniner som saknar pinnar i ursprungsklassen
                    </Label>
                </div>
                <p className="text-sm text-muted-foreground">
                    Rutan hjälper till att visa vilka kaniner som du kan ta med till ny-klass.
                </p>
            </div>
            <DataTable
                table={table}
                isLoading={isLoading}
                columns={columns(errors)}
                skeletonRows={10}
            />
        </>
    );
}
